import { useEffect, useState } from "react";
// import "./styles/indicadores.css";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
// import General from "./General";
// import WorkStation from "./WorkStation";
// import Printers from "./Printers";
// import Phones from "./Phones";
// import AccessPoint from "./AccesPoint";
// import Switches from "./Switches";
// import Routers from "./Routers";
// import Laptops from "./Laptops";
// import Fingerprints from "./Fingerprints";
import PanelCisGrupos from "./PanelCisGrupos";
import PanelMedicionesMapeoAplicados from "./Cis/catalog_mapeos_aplicados/PanelMedicionesMapeoAplicados";
import PanelCatalogMediciones from "./Cis/catalog_mapeos/PanelCatalogMediciones";
import Modal from "react-modal";
// import ModalEvents from "./ModalEvents";
// import PanelDevice from "./PanelDevice";
import { useFetch } from "../../hooks/useFetch";
import { permisos_codigo_id } from "../generales/GroupsId";
import LoadData from "../LoadData";
import LoadSimple from "../LoadSimple";
const addHostModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'80%',
    height:'70%',
    padding:'20px'
  },
};
const PanelIndicadores = ({handleShowPopup,pageSelected, globals,server, dataGlobals,languaje,mode,estados_list,userPermissions,token,estadoSelected,setEstadoSelected}) => {
  const [listSelected, setListSelected] = useState(1);
  const [techSelected, setTechSelected] = useState(0);
  const [internalError,setInternalError]=useState(false)
  const [hostSelected,setHostSelected]=useState({})
  const dataTechs=useFetch('zabbix/groups/devices/0','',token,'GET',server)
  const dataServers=useFetch('zabbix/groups/server_techs','',token,'GET',server)
  const dataAgencies=useFetch('cassia/exception_agencies','',token,'GET',server)
  const dataCriticalities=useFetch('cassia/criticalities','',token,'GET',server)
  const hadleChangeList = (e,tite) => {
    setListSelected(e);
    setTechSelected(tite)
  };
  const [addHostModalOpen, setAddHostModalOpen] =useState(false);
  function openAddHostModal() {
      
    //   console.log('open')
      setAddHostModalOpen(true);
    }

  function closeAddHostModal() {
   
      setAddHostModalOpen(false);
  }
  function showHistoric(element){
    setHostSelected(element); // Esto debería funcionar si se pasa correctamente
    openAddHostModal();      // Esto también
}
  function getTechDisp(permissions, devices) {
  const moduleName = permissions.find(p => p.description === 'lista tecnologías')?.module_name;
  return devices.find(d => d.name === moduleName) ?? null;   // ← { dispId, name, id }
}
  useEffect(()=>{
    
        if(dataTechs.loading==false){
          const techPermissions = userPermissions
    .filter(p => p.description === 'lista tecnologías');

          // 2 .  Toma el primer permiso cuyo module_name NO sea "ODD"
          const chosenPerm = techPermissions.find(p => p.module_name !== 'ODD');

          // 3 .  Busca en devices el objeto cuyo name coincida
          const match = dataTechs.data.data.find(d => d.name === chosenPerm?.module_name) ?? null;

          // 4 .  Extrae lo que necesitas
          const result = match ? { dispId: match.dispId, name: match.name } : null;

          if (!userPermissions.some(
                                 (objeto) =>
                                   objeto.permission_id === permisos_codigo_id["General"])){
            hadleChangeList(result.dispId,result.name)
          }
        }
  },[dataTechs.loading])

  const [dataAnalisis,setDataAnalisis]=useState({data:{},loading:true,error:{}})
  const token_item=localStorage.getItem('access_token')
  function search_analisis(){
    setDataAnalisis({data:{},loading:true,error:dataAnalisis.error})
      const fetchData = async () => {
        // console.log(server.url+'/api/v1/cassia/diagnosta/'+data.ip)
        try {
          const response = await fetch(server.url+'/api/v1/zabbix/groups/devices', {                 
                                 headers: {
                                   'Content-Type': 'application/json',
                                   Authorization: `Bearer ${token_item}`,
                                 },
                               });
          // console.log(response)
          if (response.ok) {
            const response_data = await response.json();

            setDataAnalisis({data:response_data.data,loading:false,error:dataAnalisis.error})

            // setDataAnalisis(response_data.data)
          } else {
            throw new Error('Error en la solicitud');
          }
        } catch (error) {
        //   setInternalError(true)
        }
      };
      fetchData();
  }
  useEffect(()=>{
    if (userPermissions.some(
                          (objeto) =>
                            objeto.permission_id === permisos_codigo_id["General"])){
      search_analisis()
    }
   
  },[])
  function renderAdminComponent() {
    try {
        switch (listSelected) {
            case 1:
                return <PanelCisGrupos userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
                ;
            case 2:
                return <PanelCatalogMediciones userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
                ;
                    case 3:
                        return <PanelMedicionesMapeoAplicados
                                  mode={mode}
                                  handleShowPopup={handleShowPopup}
                                  server={server}
                                  title='Printer'
                                  languaje={languaje}
                                  showHistoric={showHistoric}
                                />
                            ;
                            // case 4:
                            //     return <Phones
                            //               mode={mode}
                            //               handleShowPopup={handleShowPopup}
                            //               server={server}
                            //               title='Phone'
                            //               languaje={languaje}
                            //               showHistoric={showHistoric}
                            //             />
                            //         ;
                                  default:
                return <></>;
        }
    } catch (error) {
        console.error('Error rendering component:', error);
        return <div>{lang[languaje['msgErrorPagina']]}</div>;
    }
  }
  return (
    <>
    <div className={"main-config"+mode}>
       {/* {(internalError)?
            <InternalError/>
            :renderAdminComponent()} */}
       <div className='head-monitor'>
                
                <div className='menu-monitor'>
                     <ol className='compact-menu-list-monitor' style={{justifyContent:'start'}}>
                       
                        <li className={listSelected===1?'list-selected':''} onClick={() =>hadleChangeList(1)}>{'Grupos'}</li>
                        {/* <li className={listSelected===2?'list-selected':''} onClick={() =>hadleChangeList(2)}>{'Catalogo de mapeos'}</li>
                        <li className={listSelected===3?'list-selected':''} onClick={() =>hadleChangeList(3)}>{'Mapeos Aplicados'}</li> */}
                        {/* <li className={listSelected===4?'list-selected':''} onClick={() =>hadleChangeList(4)}>{capitalizeFirstLetter(lang[languaje]['telefonos'])}</li> */}
                       
                     
                    </ol>
                    <hr className='head-line-monitor'></hr>
                </div>
                
            </div>
            <div className='cont-monitor'>
            {(internalError)?
              <InternalError/>
              :((dataTechs.loading)?<LoadSimple/>:renderAdminComponent())

            }
            
                
            </div>
    </div>
    <Modal
    isOpen={addHostModalOpen}
    // isOpen={true}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closeAddHostModal}
    style={addHostModalStyles}
    contentLabel="Example Modal2"
    // shouldCloseOnOverlayClick={false}
    >
      {/* <ModalEvents dataCriticalities={dataCriticalities}  dataAgencies={dataAgencies} dataServers={dataServers} deviceId={listSelected} server={server} handleShowPopup={handleShowPopup}  hostSelected={hostSelected}  languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalEvents>  */}
      {/* <ModalHistoric  server={server} handleShowPopup={handleShowPopup}  hostSelected={hostSelected}  languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalHistoric> */}
</Modal>
{/* <Modal
    isOpen={addHostModalOpen}
    // isOpen={true}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closeAddHostModal}
    style={addHostModalStyles}
    contentLabel="Example Modal2"
    // shouldCloseOnOverlayClick={false}
    >
      <ModalHistoric  server={server} handleShowPopup={handleShowPopup}  hostSelected={hostSelected}  languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalHistoric>
</Modal> */}

</>
  );
};

export default PanelIndicadores;
